import { useState, useEffect, useRef } from "react";
import { useStudioErstellen } from "../../store/studioErstellenStore";
import offerIcon from "../../public/studioErstellen/percentageImage.webp"

import classes from "./Preis.module.css";
import Stundenpreis from "./price/Stundenpreis";
import Paketpreise from "./price/Paketpreise";
import ErrorMessage from "./ErrorMessage";

export const Preis = ({ validate }) => {
    const { studioData, updateStudioData } = useStudioErstellen();

    const [selectedPricingType, setSelectedPricingType] = useState(
        studioData?.pricingType || null
    );

    const [error, setError] = useState("");

    const handlePricingTypeChange = (type) => {
        // Switch selected pricing type in local state
        setSelectedPricingType(type);

        // Persist the selected pricing type
        updateStudioData('pricingType', type);

        // Whenever user switches pricing model, reset all pricing-related fields
        // so each model starts from a clean slate.
        updateStudioData('minNumberOfHours', '');
        updateStudioData('pricePerHour', '');
        updateStudioData('adjustPriceByPeople', false);
        updateStudioData('priceGroups', []);
        updateStudioData('discounts', []);
        updateStudioData('fees', []);
        updateStudioData('weekendSurcharge', false);
        updateStudioData('weekendDays', []);
        updateStudioData('packages', []);

        // Clear top-level pricing-type error once a valid selection is made
        if (type) {
            setError("");
        }
    };

    const CheckIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="12" fill="#1F1F1F"/>
            <line x1="6.68079" y1="11.8187" x2="10.2545" y2="15.4692" stroke="white" strokeWidth="1.55556"/>
            <line x1="9.16709" y1="15.4508" x2="17.5924" y2="7.43704" stroke="white" strokeWidth="1.55556"/>
        </svg>
    );

    // Create a stable ref to pass validation from child components
    const childValidateRef = useRef(null);

    useEffect(() => {
        validate.current = () => {
            if (!selectedPricingType) {
                setError("Bitte wähle eine der Optionen (Stundenpreis oder Paketpreise).");
                return false;
            }

            if (childValidateRef.current) {
                const result = childValidateRef.current();
                return result;
            }

            return true;
        };
    }, [validate, selectedPricingType]);

  return (
    <div className={classes.mainContainer}>
        <div className={classes.textContainer}>
            <h2 className={`${classes.title} titleSemibold`}>Preis & Stundenanzahl</h2>
            <span className="slimRegularLarge">Bestimme deinen Preis und wie viele Stunden ein Nutzer mindestens bei dir buchen muss.</span>
            {/* <div className={classes.offerContainer}>
                <div className={classes.offerIcon}>
                    <img src={offerIcon} alt="Offer Icon" />
                </div>
                <span className={classes.offerText}>
                    Als Stu Original zahlst du im Soft Launch 0% Provision.
                </span>
            </div> */}
        </div>

        <div className={classes.casesContainerChoser}>
            <div 
                className={`${classes.caseBox} ${selectedPricingType === "stundenpreis" ? classes.caseBoxSelected : ""}`}
                onClick={() => handlePricingTypeChange("stundenpreis")}
            >
                {selectedPricingType === "stundenpreis" && (
                    <div className={classes.checkBox}>
                        <CheckIcon />
                    </div>
                )}
                <h3 className="semiboldMiddle">Stundenpreis</h3>
                <p style={{color: "var(--dark-grey-4)"}} className="slimRegularLargeText">
                Lege einen Preis pro Stunde fest. Ideal für flexible Buchungen.
                </p>
            </div>
            <div 
                className={`${classes.caseBox} ${selectedPricingType === "paketpreise" ? classes.caseBoxSelected : ""}`}
                onClick={() => handlePricingTypeChange("paketpreise")}
            >
                {selectedPricingType === "paketpreise" && (
                    <div className={classes.checkBox}>
                        <CheckIcon />
                    </div>
                )}
                <h3 className="semiboldMiddle">Paketpreise</h3>
                <p style={{color: "var(--dark-grey-4)"}} className="slimRegularLargeText">
                Erstelle feste Pakete (z. B. Half-Day, Full-Day).
                </p>
            </div>
        </div>
                
        {error && (
            <div style={{ marginBottom: "12px" }}>
                <ErrorMessage>{error}</ErrorMessage>
            </div>
        )}

        <div className={`${classes.casesContainerChoserMobile} ${selectedPricingType === "stundenpreis" || selectedPricingType === "paketpreise" ? classes.displayRow : ""}`}>
            <div 
                className={`${classes.caseBox} ${selectedPricingType === "stundenpreis" || selectedPricingType === "paketpreise" ? classes.caseBoxCentered : ""}`}
                onClick={() => handlePricingTypeChange("stundenpreis")}
                style={{border: selectedPricingType === "stundenpreis" || selectedPricingType === "" ? "1.5px solid var(--dark-grey)" : "1.5px solid var(--light-grey-1)" }}
            >
                <div className={`${classes.checkBoxMobile} ${selectedPricingType === "stundenpreis" || selectedPricingType === "paketpreise" ? classes.displayNone : ""}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="white" stroke="#B1B6BB"/>
                    </svg>
                </div>
                <h3 className="semiboldMiddle">Stundenpreis</h3>
                <p style={{color: "var(--dark-grey-4)"}} className={`slimRegularLargeText ${selectedPricingType === "stundenpreis" || selectedPricingType === "paketpreise" ? classes.displayNone : ""}`}>
                Lege einen Preis pro Stunde fest. Ideal für flexible Buchungen.
                </p>
            </div>
            <div 
                className={`${classes.caseBox} ${selectedPricingType === "paketpreise" || selectedPricingType === "stundenpreis" ? classes.caseBoxCentered : ""}`}
                style={{border: selectedPricingType === "paketpreise" || selectedPricingType === "" ? "1.5px solid var(--dark-grey)" : "1.5px solid var(--light-grey-1)" }}
                onClick={() => handlePricingTypeChange("paketpreise")}
            >
                <div className={`${classes.checkBoxMobile} ${selectedPricingType === "stundenpreis" || selectedPricingType === "paketpreise" ? classes.displayNone : ""}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="white" stroke="#B1B6BB"/>
                    </svg>
                </div>
                <h3 className="semiboldMiddle">Paketpreise</h3>
                <p style={{color: "var(--dark-grey-4)"}} className={`slimRegularLargeText ${selectedPricingType === "stundenpreis" || selectedPricingType === "paketpreise" ? classes.displayNone : ""}`}>
                Erstelle feste Pakete (z. B. Half-Day, Full-Day).
                </p>
            </div>
        </div>
        
        {selectedPricingType === "stundenpreis" ? (
            <Stundenpreis validate={childValidateRef} />
        ) : selectedPricingType === "paketpreise" ? (
            <Paketpreise validate={childValidateRef} />
        ) : null
        }
    </div>
  );
};

export default Preis;
